<template>
  <el-menu
    v-if="project && access"
    :mode="mode"
    class="main-menu"
    v-bind:class="{ [mode]: true }"
    text-color="#24274a"
    active-text-color="#24274a"
    :default-active="active"
    menu-trigger="click"
    router
  >
    <el-dropdown class="projects" trigger="click" @command="action">
      <el-button type="text" size="mini">
        <strong class="name">{{ project.name }}</strong>
        <i v-if="user.roles.length > 1" class="el-icon-arrow-down el-icon--right" />
      </el-button>

      <el-dropdown-menu slot="dropdown" @command="action">
        <el-dropdown-item v-for="role in user.roles" :key="role.id" command="/">
          <div @click="$store.dispatch('role', role)">{{ role.project.name }}</div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <el-menu-item-group>
      <el-menu-item v-if="!permission('accounting')" index="/instances">Cloud Servers</el-menu-item>
      <el-menu-item v-if="!permission('accounting')" index="/applications">Applications</el-menu-item>
      <el-menu-item v-if="permission('owner') || permission('admin')" index="/team">Team</el-menu-item>
      <el-menu-item v-if="permission('owner') || permission('admin') || permission('accounting')" index="/billing">Billing</el-menu-item>
    </el-menu-item-group>
  </el-menu>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  props: {
    mode: String,
    application: Boolean,
    instance: Boolean
  },
  computed: {
    active () {
      if (this.$route.name === 'domains' || this.$route.name === 'application') {
        return '/applications'
      }
      return '/' + (this.$route.path || '').substring(1).split('/').shift()
    },
    ...mapGetters(['permission']),
    ...mapState(['project', 'access', 'user'])
  },
  methods: {
    action (command) {
      if (command[0] === '/') {
        this.$router.push(command)
      } else if (command.match(/^http/)) {
        window.open(command, '_blank')
      } else {
        this[command]()
      }
    },
    dashboard () {
      this.$router.push('/')
    },
    update (prop) {
      this.$emit('update:' + prop, true)
    },
    signout () {
      this.$store.commit('logout')
      this.$store.commit('reset')
    }
  }
}
</script>

<style lang="scss">
  @import "../theme";

  .main-menu {
    border: none;

    .el-menu-item-group {
      margin-top: 25px;
      border-color: transparent;
    }

    .el-menu-item {
      font-weight: 500;
      font-size: 14px;
    }

    .el-menu-item-group__title {
      border-left: 3px solid transparent;
    }

    .projects {
      .el-button--text {
        margin-top: 30px;
        margin-left: 20px;
        color: #000;
        text-align: left;
      }

      .name {
        max-width: 145px;
        width: 145px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
      }
    }

    &.horizontal {
      .el-menu-item-group__title {
        display: none;
      }
    }
  }

  .el-dropdown-menu.el-popper {
    .el-divider {
      margin: 8px 0;
    }
  }
  .dropdown-create, .dropdown-project {
    .el-dropdown-menu__item {
      min-width: 145px;
    }
  }
  .dropdown-create {
    .el-dropdown-menu__item {
      strong {
        display: block;
        margin-bottom: -18px;
      }
    }
  }
</style>

<style lang="scss" scoped>
  @import "../theme";

  .main-menu {
    margin: 0;
    padding-left: 0;
    height: 100%;
    background-color: transparent;
    border-color: $--border-color-base;

    &.horizontal {
      position: relative;
      padding-right: 48px;
      padding-left: 48px;

      > .el-menu-item {
        background-color: transparent;

        &.is-active {
          border-bottom-color: $--color-primary !important;
          color: $--color-primary !important;

          &.menu-right {
            border-bottom-color: transparent !important;
          }
        }
        &.support {
          .el-badge {
            position: relative;
            top: -3px;
          }
          &.is-active {
            border-color: $--support-color-base;
            color: $--support-color-base !important;
          }
        }

        &:hover, &:active {
          background-color: transparent;
        }
      }

      .menu-right {
        position: absolute;
        right: 34px;

        .project {
          margin: 0;
        }

        .create {
          .el-button {
            margin: 0 40px 0 0;
            padding-top: 9px;
            padding-bottom: 9px;
            font-size: 12px;
            border-radius: 3px;
          }
        }
      }

      > .el-menu-item-group {
        display: none;
      }
    }

    &.vertical {
      .create {
        position: absolute;
        top: 80px;
        left: 23px;

        > .el-button {
          width: 100%;
        }

        .el-icon--left {
          display: none;
        }
      }

      .el-menu-item {
        margin: 0;
        background-color: transparent;
        border-left: 3px solid transparent;

        &.is-active {
          border-color: $--color-primary;
          color: $--color-primary !important;
          background-color: $--background-color-base;

          &.menu-right {
            border-color: transparent !important;
          }
        }
      }
    }

    .project {
      line-height: 36px;
      margin: 20px 0 15px;

      .el-dropdown-link {
        cursor: pointer;
      }

      .name {
        max-width: 115px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
      }
    }

    .create {
      .el-button {
        background-image: url(../assets/logo-icon-white.svg);
        background-repeat: no-repeat;
        background-position: center left 10px;
        background-size: 20px;
        padding-left: 40px;
      }
    }
  }
</style>
